import { makeBridgeRequest } from 'common/helpers'
import { PostReportRequest } from 'common/types'

import { getReportViaEmailUS } from './us-api'

export async function requestReportViaEmailUS(reportRequest: PostReportRequest) {
  return makeBridgeRequest(getReportViaEmailUS(reportRequest)).then((response) => response)
}
